import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const EQUIPMENT_CATALOG_CHANGES_CRUD_ACTION_CONSTANTS =
	crudActionConstantsGenerator('PART_CATALOGS');
export const EQUIPMENT_CATALOG_CHANGES_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	EQUIPMENT_CATALOG_CHANGES_CRUD_ACTION_CONSTANTS
);
